import classNames from 'classnames'

import { useTimeZone } from '../../../../hooks'
import { getQaSelector } from '../../../../utils/common'
import { getCalendarGridCellStart } from '../CalendarGridWeek.utils'

import { QA_NAME_CALENDAR_GRID_CELL } from './CalendarGridWeekCell.constants'
import { useCalendarGridWeekCellHandlers } from './CalendarGridWeekCell.hooks'
import {
  getIsCalendarGridWeekCellDisabled,
  getIsCalendarGridWeekCellPast,
} from './CalendarGridWeekCell.utils'

import * as styles from './CalendarGridWeekCell.module.css'

function CalendarGridWeekCell({
  className = styles.CalendarGridWeekCell,
  day,
  hour,
  isLast,
  isSelected,
  now,
  onClick,
  onPointerDown,
  onPointerEnter,
}) {
  const timezone = useTimeZone()

  const start = getCalendarGridCellStart({ day, hour, timezone })

  const isPast = getIsCalendarGridWeekCellPast({ now, start })

  const isDisabled = getIsCalendarGridWeekCellDisabled({ isPast, onClick })

  const { handleClick, handlePointerDown, handlePointerEnter } =
    useCalendarGridWeekCellHandlers({
      day,
      hour,
      isDisabled,
      isPast,
      start,
      onClick,
      onPointerDown,
      onPointerEnter,
    })

  return (
    <div
      {...getQaSelector({
        context: `${day}_${hour}`,
        value: QA_NAME_CALENDAR_GRID_CELL,
      })}
      className={classNames(className, {
        [styles.disabled]: isDisabled,
        [styles.last]: isLast,
        [styles.selected]: isSelected,
      })}
      onClick={handleClick}
      onPointerDown={handlePointerDown}
      onPointerEnter={handlePointerEnter}
    />
  )
}

export default CalendarGridWeekCell
